import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';

export const useAppLanguage = () => {
  //return 'en';
  const { language } = useSelector(
    (rootState: RootState) => rootState.language,
  );
  return language;
};

export default useAppLanguage;
